import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import css from 'styles/components/landing/iframe.scss';
import { fetchCustomerDirectedIdAndAppend } from 'actions/landing/iframe';

export class Iframe extends Component {

  componentDidMount() {
    const {
      landing: {
        pageInfo: {
          customerAuth
        }
      },
      slotDetails: {
        iframe: {
          href
        }
      },
      fetchCustomerDirectedIdAndAppend
    } = this.props;
    if (customerAuth === 'FULL' && href.includes('sheerid')) { // append customer directId to SheerId iframe src
      fetchCustomerDirectedIdAndAppend(href);
    }
  }

  render() {
    const { slotDetails: { iframe, monetateId }, iframe: stateIframe } = this.props;
    const { href, sandbox, width, height, frameborder, title } = iframe;
    const { updatedHref } = stateIframe;
    const iframeHref = updatedHref || href;
    const style = {
      height: height || null,
      width: width || null
    };

    if (iframeHref) {
      return (
        <div className={css.iframeWrapper} data-monetate-id={monetateId}>
          <iframe
            title={title}
            src={iframeHref}
            sandbox={sandbox}
            width={width}
            height={height}
            style={style}
            frameBorder={frameborder || '0'}></iframe>
        </div>
      );
    } else {
      return false;
    }
  }
}

Iframe.propTypes = {
  slotDetails: PropTypes.shape({
    href: PropTypes.string,
    height: PropTypes.string
  }).isRequired
};

const mapStateToProps = state => ({
  landing: state.landingPage,
  iframe: state.iframe
});

export default connect(mapStateToProps, {
  fetchCustomerDirectedIdAndAppend
})(Iframe);
